var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"playerContaine",class:['flv-player', { 'flv-playing': _vm.isPlaying }]})
}
var staticRenderFns = []

export { render, staticRenderFns }